import { t } from '../../strings/i18n/i18n';
import theme from '../../theme';
var colors = theme.colors, statusColors = theme.statusColors;
export var STATUS;
(function (STATUS) {
    STATUS["DISPUTE_OPENED"] = "Dispute Opened";
    STATUS["DISPUTE_UNDER_REVIEW"] = "Dispute Under Review";
    STATUS["DISPUTE_COMPLETED"] = "Dispute Completed";
    STATUS["CLAIM_OPENED_PENDING"] = "CLAIM_OPENED_PENDING";
    // todo: confirm with API team on below two statuses
    STATUS["DISPUTE_CANCELED"] = "DISPUTE CANCELED";
    STATUS["DISPUTE_CANCEL_PENDING"] = "DISPUTE CANCEL PENDING";
    STATUS["CANCELATION_PENDING"] = "Cancelation Pending";
})(STATUS || (STATUS = {}));
var DisputeType;
(function (DisputeType) {
    DisputeType["error"] = "error";
    DisputeType["success"] = "success";
    DisputeType["warning"] = "warning";
    DisputeType["info"] = "info";
})(DisputeType || (DisputeType = {}));
// eslint-disable-next-line max-lines-per-function
export var determineTitle = function (status) {
    switch (status) {
        case STATUS.DISPUTE_OPENED:
        case STATUS.CLAIM_OPENED_PENDING:
            return {
                title: t('eligibility.disputeOpened'),
                background: colors.lightYellow,
                borderColor: statusColors.yellowBorder,
                flagColor: statusColors.yellowFlag,
                type: DisputeType.warning
            };
        case STATUS.DISPUTE_UNDER_REVIEW:
            return {
                title: t('eligibility.disputeUnderReview'),
                background: colors.lightYellow,
                borderColor: statusColors.yellowBorder,
                flagColor: statusColors.yellowFlag,
                type: DisputeType.warning
            };
        case STATUS.DISPUTE_COMPLETED:
            return {
                title: t('eligibility.disputeCompleted'),
                background: statusColors.greenBground,
                borderColor: statusColors.greenBorder,
                flagColor: colors.greenText,
                type: DisputeType.success
            };
        case STATUS.DISPUTE_CANCELED:
            return {
                title: t('eligibility.disputeCanceled'),
                background: colors.claimBground,
                borderColor: statusColors.redBorder,
                flagColor: statusColors.redFlag,
                type: DisputeType.error
            };
        case STATUS.DISPUTE_CANCEL_PENDING:
        case STATUS.CANCELATION_PENDING:
            return {
                title: t('eligibility.cancelationPending'),
                background: statusColors.blueBground,
                borderColor: statusColors.blueBorder,
                flagColor: statusColors.blueFlag,
                type: DisputeType.info
            };
        default:
            return {
                title: status,
                background: statusColors.blueBground,
                borderColor: statusColors.blueBorder,
                flagColor: statusColors.blueFlag,
                type: DisputeType.info
            };
    }
};
export default determineTitle;
//# sourceMappingURL=helpers.js.map